import cn from 'classnames';
import { Col, Row } from 'ui';
import { useCalendarSettings } from '../../storages';
import type { CalendarSearchParamsOptions } from '../../types';
import { MainContent } from './main-content';
import { SidePanel } from './side-panel';

type P = {
  getPathToEventDetail: (id: string) => string;
  navigateToEventDetail: (id: string) => Promise<void>;
  searchParamsOptions: CalendarSearchParamsOptions;
};

const Content = ({
  getPathToEventDetail,
  navigateToEventDetail,
  searchParamsOptions: { date, updateSearchParams },
}: P) => {
  const [{ isOpen, mode }] = useCalendarSettings();

  return (
    <Row className="calendar-content" gutter={isOpen ? 'ms' : 0} wrap={false}>
      <Col
        className={cn('calendar-content__side-panel', { 'calendar-content__side-panel--closed': !isOpen })}
        flex="none"
      >
        <SidePanel
          date={date}
          getPathToEventDetail={getPathToEventDetail}
          isOpen={isOpen}
          mode={mode}
          updateSearchParams={updateSearchParams}
        />
      </Col>
      <Col className="calendar-content__main" flex={1}>
        <MainContent
          date={date}
          getPathToEventDetail={getPathToEventDetail}
          navigateToEventDetail={navigateToEventDetail}
          updateSearchParams={updateSearchParams}
        />
      </Col>
    </Row>
  );
};

export default Content;
